import { type ColumnKey, type SortKey } from '@/typings/twitter_benchmark_campaign_posts'

export interface TwBenchmarkDefaultTableColums {
  key: ColumnKey
  label: string
  width: number
  tooltip?: string
  sortable: boolean
  sortKey?: SortKey
}

const WIDTH_TEXT = 160
const WIDTH_NUMBER = 140
const WIDTH_IMPRESSIONS = 180
const WIDTH_DETAIL = 240
const WIDTH_PERIOD = 200
const WIDTH_BATCH = 200

export const DEFAULT_COLUMN: Record<ColumnKey, TwBenchmarkDefaultTableColums> = {
  campaign_type: { key: 'campaign_type', label: 'キャンペーン形式', width: WIDTH_BATCH, sortable: false },
  incentive: { key: 'incentive', label: 'インセンティブ', width: WIDTH_BATCH, sortable: false },
  winner_count: {
    key: 'winner_count',
    label: '当選人数',
    width: WIDTH_NUMBER,
    sortable: true,
    sortKey: 'winnerCount',
    tooltip: '投稿テキストや画像をAIが分析し、当選人数を抽出しています。判別できなかった場合は「-」を表示します。'
  },
  impressions_count: {
    key: 'impressions_count',
    label: 'インプレッション',
    width: WIDTH_IMPRESSIONS,
    sortable: true,
    sortKey: 'impressionsCount'
  },
  likes_count: { key: 'likes_count', label: 'いいね', width: WIDTH_NUMBER, sortable: true, sortKey: 'likesCount' },
  retweets_count: {
    key: 'retweets_count',
    label: 'リポスト',
    width: WIDTH_NUMBER,
    sortable: true,
    sortKey: 'retweetsCount'
  },
  quotes_count: { key: 'quotes_count', label: '引用数', width: WIDTH_NUMBER, sortable: true, sortKey: 'quotesCount' },
  replies_count: {
    key: 'replies_count',
    label: '返信数',
    width: WIDTH_NUMBER,
    sortable: true,
    sortKey: 'repliesCount'
  },
  reactions_count: {
    key: 'reactions_count',
    label: '反応数',
    width: WIDTH_NUMBER,
    sortable: true,
    sortKey: 'reactionsCount',
    tooltip: 'リポスト + いいね + 引用 + 返信'
  },
  reactions_rate: {
    key: 'reactions_rate',
    label: '反応率',
    width: WIDTH_NUMBER,
    sortable: true,
    sortKey: 'reactionsRate',
    tooltip: '(リポスト + いいね + 引用 + 返信) / フォロワー数'
  },
  campaign_period: {
    key: 'campaign_period',
    label: 'キャンペーン期間',
    width: WIDTH_PERIOD,
    sortable: true,
    sortKey: 'campaignStartDatetime',
    tooltip: '終了日が取得できなかった場合は、開始日から 10 日後を終了日とみなしてデータを更新します。'
  },
  campaign_days: {
    key: 'campaign_days',
    label: '開催日数',
    width: WIDTH_NUMBER,
    sortable: true,
    sortKey: 'campaignDays',
    tooltip:
      'キャンペーン開催期間に端数の時間が含まれる場合は、切り上げて日数を表示します（例: 4 日 5 時間 → 5 日、3 日 23 時間 → 4 日）。'
  },
  last_synced_at: {
    key: 'last_synced_at',
    label: 'データ取得日時',
    width: WIDTH_PERIOD,
    sortable: true,
    sortKey: 'lastSyncedAt',
    tooltip:
      'エンゲージメント数値（インプレッション・いいね・リポスト・引用・返信・反応数・反応率）が取得された日時です。キャンペーン終了後に一度のみ取得します。'
  },
  is_trend: {
    key: 'is_trend',
    label: 'トレンド実績',
    width: WIDTH_TEXT,
    sortable: false,
    tooltip: 'トレンド実績は1時間ごとに情報を更新しています'
  },
  campaign_detail: {
    key: 'campaign_detail',
    label: 'キャンペーン詳細',
    width: WIDTH_DETAIL,
    sortable: false,
    tooltip: '投稿テキストや画像をAIが分析し、キャンペーン詳細を抽出しています'
  }
}

export const DEFAULT_TABLE_COLUMNS: readonly TwBenchmarkDefaultTableColums[] = Object.values(DEFAULT_COLUMN)

export const DEFAULT_TABLE_COLUMNS_KEY: ReadonlyMap<ColumnKey, TwBenchmarkDefaultTableColums> = new Map(
  DEFAULT_TABLE_COLUMNS.map(col => [col.key, col])
)
